import { useContext } from 'react';
import { ApprovalContext } from '../context/approvalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const renderIfEditable = WrappedComponent => {
  const RenderIfEditable = props => {
    const approval = useContext(ApprovalContext);
    if (!approval || !approval.data) {
      return null;
    }
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  };
  return RenderIfEditable;
};